import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import "./WarningScreen.css";
import Profile from "../img/workfolio-latest.png";
var WarningScreen = function WarningScreen(props) {
  React.useEffect(function () {
    var _localStorage;
    (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.removeItem("token");
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "WarningScreen-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: "WarningScreen-root-img"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Workfolio",
    src: Profile,
    className: " m-b-20",
    width: "40",
    height: "40"
  })), /*#__PURE__*/React.createElement("p", {
    className: "WarningScreen-text-sry"
  }, "Sorry for the inconvenience."), /*#__PURE__*/React.createElement("p", {
    className: "WarningScreen-text"
  }, "We are recommending you to visit from computer for better experience."));
};
export default WarningScreen;